<template>
  <div class="footer py-11 primary darken-4">
    <v-container class="py-0">
      <div
        class="d-flex align-center flex-column flex-sm-row justify-center justify-sm-space-between"
      >
        <div class="copyright white--text">
          @ {{ `${year} ${name}` }}. Todos os Direitos Reservados.
        </div>

        <div class="mrx mt-4 mt-sm-0">
          <a href="https://mrxweb.com.br" target="_blank">
            <img
              class="mrx-logo"
              src="/img/mrxweb.svg"
              alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
              title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            />
          </a>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    name() {
      return this.$rest("informations").item.short_name;
    },
  },
};
</script>

<style scoped>
.copyright {
  font-size: 16px;
}

.mrx-logo {
  display: block;
  height: 20px;
}
</style>
